import * as React from "react";
import { Box, Typography } from "@mui/material";
import { platformFonts, usePlatformColors } from "../tickitPlatformTheme";

export default function PlatformAnalyticBar({ label, value, percent, color }) {
  const colors = usePlatformColors();
  const barColor = color || colors.brand;
  const pct = Math.min(100, Math.max(0, percent ?? 0));
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 1.5 }}>
      <Typography
        sx={{
          width: 120,
          flexShrink: 0,
          fontSize: "13px",
          color: "var(--platform-text-2)",
          fontFamily: platformFonts.body,
        }}
      >
        {label}
      </Typography>
      <Box
        sx={{
          flex: 1,
          height: 8,
          bgcolor: "var(--platform-surface-3)",
          borderRadius: 99,
          overflow: "hidden",
        }}
      >
        <Box sx={{ width: `${pct}%`, height: "100%", bgcolor: barColor, borderRadius: 99 }} />
      </Box>
      <Typography
        sx={{
          width: 40,
          flexShrink: 0,
          textAlign: "right",
          fontSize: "12px",
          fontWeight: 700,
          color: "var(--platform-text-2)",
          fontFamily: platformFonts.body,
        }}
      >
        {value}
      </Typography>
    </Box>
  );
}
